import * as React from 'react'
const DocumentCenterIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path d="M4.5 27a.5.5 0 01-.5-.5v-18a.5.5 0 01.5-.5H7V5.5a.5.5 0 01.5-.5h10a.5.5 0 01.5.5V8h8.5a.5.5 0 01.5.5v6a.5.5 0 01-1 0V9h-8.5a.5.5 0 01-.5-.5V6H8v2.5a.5.5 0 01-.5.5H5v17.5a.5.5 0 01-.5.5z" className="-secondary-color" fill="#d7dae0"/>
      <path d="M26.5 27h-22a.49.49 0 01-.39-.19.51.51 0 01-.1-.43l3-12A.51.51 0 017.5 14h22a.49.49 0 01.39.19.48.48 0 01.09.43l-3 12a.49.49 0 01-.48.38zM5.14 26h21l2.75-11h-21z" className="-primary-color" fill="#a5aab8"/>
    </svg>
    
  )
}

export default DocumentCenterIcon